import './InteractiveMenu.css';
import renzLogo from '../../assets/renz-simple_transparent.png';
import instalogo from '../../assets/transparent-instagram-logo-translucent-1.png';
import renzGrindzCircle from '../../assets/renzfoods-logo_transparent.png';

function InteractiveMenu() {
    return (
        <div className="interactive-menu">
            <div className="im-background-logo-container">
                <img src={renzGrindzCircle} alt="Renz Grindz" className="im-background-logo" />
            </div>
            <div className="interactive-menu-container">
                {/* Header */}
                <div className="im-header">
                    <div className="im-logo-container">
                        <img src={renzLogo} alt="Renz Logo" className="im-logo" />
                    </div>
                    <div className="im-order-info">
                        {/* <p className="im-order-text">TO ORDER, PLEASE SEND US A DM!</p> */}
                        <div className="im-contact-info">
                            <div className="im-contact-item">
                                {/* <span className="im-icon instagram-icon">📷</span> */}
                                <img src={instalogo} alt="Instagram Logo" className="im-icon instagram-icon" />
                                <span>@RENZPOKE</span>
                            </div>
                            <div className="im-contact-item">
                                <span className="im-icon web-icon">🌐</span>
                                <span>RENZFOODS.COM</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="im-header-divider"></div>

                {/* Main Content */}
                <div className="im-content">
                    {/* Left Column - Poke */}
                    <div className="im-column">
                        <div className="im-section-title">POKE</div>
                        <div className="im-section-subtitle">8oz.</div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">THE HAWAIIAN*</span>
                                <span className="im-item-price">$9.50</span>
                            </div>
                            <ul className="im-item-description">
                                <li>classic Hawaiian ahi poke with chili water and ogo limu</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">
                                    <span className="im-spicy-icon">⭐</span>GOCHU-MAYO*
                                </span>
                                <span className="im-item-price">$9.50🌶️</span>
                            </div>
                            <ul className="im-item-description">
                                <li>choice of ahi or salmon. mayo, gochugiang, sesame</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">MISO SHOYU*</span>
                                <span className="im-item-price">$9.50</span>
                            </div>
                            <ul className="im-item-description">
                                <li>choice of ahi or salmon, Renz miso glaze</li>
                            </ul>
                        </div>

                        <div className="im-section-divider"></div>

                        {/* Spam Musubi Section */}
                        <div className="im-section-title">SPAM MUSUBI</div>
                        <div className="im-section-subtitle">1pc.</div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">
                                    <span className="im-spicy-icon">⭐</span>OG
                                </span>
                                <span className="im-item-price">$2.50</span>
                            </div>
                            <ul className="im-item-description">
                                <li>teriyaki sauce, furikake</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">FRIED RICE</span>
                                <span className="im-item-price">$3.50</span>
                            </div>
                            <ul className="im-item-description">
                                <li>garlic, teriyaki sauce</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">KIMCHI</span>
                                <span className="im-item-price">$4.50🌶️</span>
                            </div>
                            <ul className="im-item-description">
                                <li>kimchi, garlic, teriyaki sauce</li>
                            </ul>
                        </div>

                        <div className="im-section-divider"></div>

                        {/* Drinks Section */}
                        <div className="im-section-title">DRINKS</div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">HAWAIIAN SUN</span>
                                <span className="im-item-price">$2.00</span>
                            </div>
                            <ul className="im-item-description im-small">
                                <li>green tea lychee, orange-nectar, lilikoi passion</li>
                            </ul>
                        </div>
                    </div>

                    {/* Vertical Divider */}
                    <div className="im-vertical-divider"></div>

                    {/* Right Column - Inari Bombs & Sides */}
                    <div className="im-column">
                        {/* Inari Bombs Section */}
                        <div className="im-section-title">INARI BOMBS</div>
                        <div className="im-section-subtitle">4pcs.</div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">SPICY TUNA*</span>
                                <span className="im-item-price">$8.00🌶️</span>
                            </div>
                            <ul className="im-item-description">
                                <li>tofu pocket with tuna, mayo, gochugiang</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name">CALIFORNIA</span>
                                <span className="im-item-price">$6.00</span>
                            </div>
                            <ul className="im-item-description">
                                <li>tofu pocket with krab, mayo, green onions</li>
                            </ul>
                        </div>

                        <div className="im-section-divider"></div>

                        {/* Sides Section */}
                        <div className="im-section-title">SIDES</div>
                        <div className="im-section-price">$2.50</div>
                        <div className="im-section-subtitle">6oz.</div>

                        <ul className="im-item-description im-simple-list">
                            <li>SPICY GARLIC EDAMAME</li>
                            <li>OCEAN SALAD</li>
                            <li>ASIAN SLAW</li>
                            <li>CUCUMBER SALAD</li>
                        </ul>

                        {/* Rice Subsection */}
                        <div className="im-subsection-title">RICE</div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name im-rice-item">WHITE RICE</span>
                                <span className="im-item-price">$0.50</span>
                            </div>
                            <ul className="im-item-description im-small">
                                <li>1 scoopz</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name im-rice-item">GARLIC FRIED RICE</span>
                                <span className="im-item-price">$4.00</span>
                            </div>
                            <ul className="im-item-description im-small">
                                <li>spam, garlic - 2 scoopz</li>
                            </ul>
                        </div>

                        <div className="im-item">
                            <div className="im-item-header">
                                <span className="im-item-name im-rice-item">KIMCHI FRIED RICE</span>
                                <span className="im-item-price">$5.00🌶️</span>
                            </div>
                            <ul className="im-item-description im-small">
                                <li>spam, kimchi, garlic - 2 scoopz</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Footer Warning */}
                <div className="im-footer">
                    <p className="im-warning-text">
                        *CONSUMING RAW OR UNDERCOOKED MEATS, POULTRY, SEAFOOD, SHELLFISH, OR EGGS MAY INCREASE YOUR RISK OF FOODBORNE ILLNESS, ESPECIALLY IF YOU HAVE CERTAIN MEDICAL CONDITIONS.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default InteractiveMenu;
